import { TableContainer, styled } from '@mui/material';

export const BudgetTableContainer = styled(TableContainer)(({ theme }) => ({
  boxShadow: 'none',
  backgroundColor: theme.palette.common.white,

  '& .MuiTableHead-root': {
    height: '44px',

    '& .MuiTableCell-head': {
      verticalAlign: 'middle',
      borderBottom: `1px solid ${theme.palette.border.main}`,
      borderTop: `1px solid ${theme.palette.border.main}`,
    },

    '& .MuiTableCell-head:last-child': {
      paddingRight: '32px',
    },
  },

  '& .MuiTableBody-root': {
    '& .MuiTableRow-root': {
      borderColor: theme.palette.border.main,
      height: '65px',
    },

    '& .MuiTableCell-root': {
      padding: '12px 16px',
      borderBottom: 'none',
    },

    '& .MuiTableCell-root:last-child': {
      paddingRight: '32px',
    },
  },

  // styles for nested collapsible table
  '& .MuiCollapse-root': {
    '& .MuiTableHead-root': {
      height: '32px',

      '& .MuiTableCell-head': {
        padding: '3px 16px',
        borderBottom: 'none',
        position: 'relative',
      },

      '& .MuiTableCell-head:last-child': {
        paddingRight: '32px',
      },
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        borderBottom: 'none',
      },

      '& .MuiTableCell-root': {
        position: 'relative',

        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          height: '1px',
          backgroundColor: theme.palette.border.main,
        },

        '&:first-child': {
          paddingLeft: '32px',

          '&::after': {
            left: '20px',
            width: 'calc(100% - 20px)',
          },
        },

        '&:last-child': {
          paddingRight: '32px',
        },
      },
    },
  },
}));
